import httpCommon from "./http-common";

// Get transaction item count
const getAllTransactionsCount = () => {
  return httpCommon.get(`/v1/get/count/transactions`);
};

// Get user count
const getAllUsersCount = () => {
  return httpCommon.get(`/v1/get/count/users`);
};

// Get customer count
const getAllCustomersCount = () => {
  return httpCommon.get(`/v1/get/count/customers`);
};

// Get business count
const getAllBusinessesCount = () => {
  return httpCommon.get(`/v1/get/count/businesses`);
};

const getAllInvoicesCount = (businessId: number) => {
  return httpCommon.get(`/v1/get/count/invoices/${businessId}`);
};

const getAllQuotationsCount = (businessId: number) => {
  return httpCommon.get(`/v1/get/count/quotations/${businessId}`);
};

const getAllReceiptsCount = (businessId: number) => {
  return httpCommon.get(`/v1/get/count/receipts/${businessId}`);
};

const CountsService = {
    getAllTransactionsCount,
    getAllUsersCount,
    getAllCustomersCount,
    getAllBusinessesCount,
    getAllInvoicesCount,
    getAllQuotationsCount,
    getAllReceiptsCount,
};
export default CountsService;
